<div class="table-container">
  <table mat-table [dataSource]="usersDataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef> Role </th>
      <td mat-cell *matCellDef="let element">
        <mat-select class="role-select" placeholder="No access" [(value)]="element.role" (selectionChange)="errorMessage && isValid()" [attr.aria-label]="'Access for ' + element.name">
          <mat-option [value]="undefined">No access</mat-option>
          @for (r of roles; track r) {
            <mat-option [value]="r.value">{{r.name}}</mat-option>
          }
        </mat-select>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
@if (errorMessage) {
  <mat-error class="error">{{errorMessage}}</mat-error>
}
